import React from 'react';
import { X, Check } from 'lucide-react';
export const BeforeAfterSection: React.FC = () => {
  return <section className="py-16 bg-stone-100" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-3">
          Antes vs Después{' '}
          <span className="text-gray-500 font-normal text-xl block mt-2" data-id="element-4">
            (lo que cambia cuando lo tenés)
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-5">
          {/* Before */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-red-400" data-id="element-6">
            <h3 className="text-xl font-bold text-red-600 mb-6 flex items-center gap-2" data-id="element-7">
              <span className="bg-red-100 p-1 rounded" data-id="element-8">
                <X className="w-5 h-5" data-id="element-9" />
              </span>
              Antes (sin el pack)
            </h3>
            <ul className="space-y-4" data-id="element-10">
              {['Buscás guías por todos lados y adaptás como podés', 'Explicás temas difíciles sin apoyo visual suficiente', 'Te cuesta mantener atención porque “no lo ven”', 'Los trabajos prácticos dependen de si encontrás algo a tiempo', 'Las evaluaciones te llevan horas porque hay que inventar todo', 'Juntás materiales… pero desordenados y poco aplicables'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-600" data-id="element-11">
                  <X className="w-5 h-5 text-red-300 mt-0.5 flex-shrink-0" data-id="element-12" />
                  <span data-id="element-13">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* After */}
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-green-500 transform md:-translate-y-4" data-id="element-14">
            <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg" data-id="element-15">
              RECOMENDADO
            </div>
            <h3 className="text-xl font-bold text-green-700 mb-6 flex items-center gap-2" data-id="element-16">
              <span className="bg-green-100 p-1 rounded" data-id="element-17">
                <Check className="w-5 h-5" data-id="element-18" />
              </span>
              Después (con el MegaPack)
            </h3>
            <ul className="space-y-4" data-id="element-19">
              {['Abrís la unidad y ya tenés guía + actividades listas', 'Explicás con claridad porque hay apoyo visual y estructura', 'Aplicás prácticas simples para que lo entiendan en serio', 'Tenés recursos variados para distintos niveles', 'Evaluás con instrumentos listos (pruebas + pautas + rúbricas)', 'Todo está organizado por carpetas (sin caos)'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-800 font-medium" data-id="element-20">
                  <Check className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" data-id="element-21" />
                  <span data-id="element-22">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
};